<template>
  <toast-msg
    v-if="showToastMsg"
    :data-img="staticImgBaseUrl + '/images/global/itemToastIcon.svg'"
    :data-text="toastMsg"
    :data-style="'address-toast-msg'"
    :data-text-color="'textWhite'"
  ></toast-msg>
</template>

<script>
import Utility from "../helpers/utility";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";
import { defineAsyncComponent } from "vue";
export default {
  name: "NotifyToastMessage",
  components: {
    ToastMsg: defineAsyncComponent(() => import("./ToastMsg.vue")),
  },
  data() {
    return {
      staticImgBaseUrl,
    };
  },
  mounted() {
    if (this.toastMessageList.length > 0) {
      this.$store.dispatch(keyMapsAction.GET_TOAST_MESSAGES_FROM_LOCAL_STORAGE);
    }
  },
  computed: {
    showToastMsg() {
      return this.$store.state.NotifyToast.showToastMsg;
    },
    toastMsg() {
      return this.$store.state.NotifyToast.toastMessage;
    },
    toastMessageList() {
      return LocalStorageFunc.getToastNotifications();
    },
  },
};
</script>
